var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"limit-wrap"},[_c('div',{staticClass:"limit-padding",style:({ background: _vm.bg })},[_c('div',{staticClass:"limit-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }